"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
exports.default = (0, styles_1.makeStyles)(function (theme) {
    return (0, styles_1.createStyles)({
        root: {
            height: '100%',
            width: '100%',
            position: 'relative',
        },
        inner: {
            height: '100%',
            width: '100%',
        },
        loadingIndicator: {
            color: theme.palette.grey[600],
            backgroundColor: theme.palette.background.paper,
        },
        controls: {
            bottom: theme.spacing(2.5),
            left: theme.spacing(2),
            position: 'absolute',
        },
        buttons: {
            backgroundColor: theme.palette.grey[800],
            '& > button': {
                backgroundColor: theme.palette.grey[800],
                color: '#fff',
            }
        }
    });
});
